import { CommonModule } from '@angular/common';``
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from "@angular/material/icon";
import { ApiService, handlePublicApiError } from '../../services/api/api.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { FloatLabelModule } from "primeng/floatlabel";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { CardModule } from "primeng/card";
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService } from 'src/services/toast/toast.service';
import { UserService } from 'src/services/user/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CardModule,
    CommonModule,
    ButtonModule,
    MatIconModule,
    PasswordModule,
    InputTextModule,
    FloatLabelModule,
    InputGroupModule,
    ReactiveFormsModule,
    ProgressSpinnerModule,
    InputGroupAddonModule,
  ]
})
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    email: new FormControl(""),
    password: new FormControl("")
  });

  showPassword = signal(false);
  loading = signal(false);

  constructor(
    private router: Router,
    private api: ApiService,
    private userService: UserService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {}

  login(): void {
    const { email: authIdentifier, password } = this.loginForm.value;
    this.loading.set(true);
    this.api.post("backend/auth/login", { authIdentifier, password }).subscribe(async (response) => {
      try {
        await this.userService.login();
        this.router.navigate(["/profile"]);
      } catch (e) {
        this.loading.set(false);
      }
    }, (e: HttpErrorResponse) => {
      this.loading.set(false);
      handlePublicApiError(e, this.toastService);
    });
  }

}
